var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-parallax",
    {
      attrs: {
        dark: "",
        src: "https://i.ytimg.com/vi/AeP7CVDEQGg/maxresdefault.jpg"
      }
    },
    [
      _c(
        "v-layout",
        { attrs: { "align-center": "", column: "", "justify-center": "" } },
        [
          _c("h1", { staticClass: "display-2 font-weight-thin mb-3" }, [
            _vm._v("Great. Transaction was succesful!")
          ]),
          _vm._v(" "),
          _c("h4", { staticClass: "subheading" })
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0f916b07", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0f916b07","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/artists/transaction_completed.vue
// module id = null
// module chunks = 